import type { ReactEventHandler } from 'react';
import { noProductCardImage } from '@images';

export const createImageErrorHandler =
  (fallback: string): ReactEventHandler<HTMLImageElement> =>
  e => {
    const img = e.currentTarget;
    if (img.getAttribute('src') === fallback) {
      return;
    }
    img.src = fallback;
  };

export const onImageError = createImageErrorHandler(noProductCardImage);
